module.exports = __webpack_public_path__ + "static/airport.9a5b2638.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/airport.png
// module id = 708
// module chunks = 154382131621592